import { makeAutoObservable } from 'mobx';
import def from './def';
import menu from './menu';
import exceptGroup from './except_group';

class Data {
	s = {
		def,
		menu,
		exceptGroup,
	};
	constructor(props) {
		makeAutoObservable(this);
	}
}

export default new Data();
